const cache = {};

export function getAddressData(zipCode) {
    Object.keys(cache).forEach(key => delete cache[key]);

    return new Promise((resolve, reject) => {
        fetch('https://viacep.com.br/ws/' + zipCode + '/json/')
            .then((response) => response.json())
            .then(function (response) {
                if (!response.erro) {
                    cache[zipCode] = response;
                    resolve(response);
                } else {
                    reject('CEP não encontrado');
                }
            })
            .catch(function (error) {
                console.error('Erro ao buscar endereço', error);
                reject(error);
            });
    });
}



export function getLeadBackend(email) {
    return new Promise((resolve) => {
        fetch(
            'https://api.varejistaonline.com/apiv3?action=check-lead&email=' + email
        )
            .then((response) => response.json())
            .then(function (response) {
                if (response.lead) {
                    let input_valid = []

                    response.phone_number !== ''
                        ? ''
                        : input_valid.push('phone_number')
                    response.lead.zip_code !== ''
                        ? ''
                        : input_valid.push('zip_code')
                    response.lead.number !== ''
                        ? ''
                        : input_valid.push('number')
                    response.lead.neighborhood !== ''
                        ? ''
                        : input_valid.push('neighborhood')
                    response.lead.city !== ''
                        ? ''
                        : input_valid.push('city')
                    response.lead.state !== ''
                        ? ''
                        : input_valid.push('state')
                    response.lead.document !== ''
                        ? ''
                        : input_valid.push('cpf')

                    let response_data = {}
                    response_data = Object.assign(response, {
                        invalids: input_valid[0],
                    })
                    resolve(response_data)
                } else {
                    resolve(response)
                }
            })
            .catch(function (error) {
                console.error(error)
                resolve(error)
                // return error;
            })
    })
}

// UPDATES REQUESTS
export function saveCustomer(values){

    return new Promise((resolve, reject) => {

        if(typeof values.email !== 'undefined' && values.email !== ''){
            fetch('https://api-fornpay.dev/api/customers/', {
                method: 'POST',
                body: JSON.stringify({
                    customer: values,
                }),
            })
                .then((response) => response.json())
                .then((result) => {
                    // do something with the result
                    // let customer = store.getters['session/getData'].customer;
                    // let data_updated = Object.assign(customer, {id: result.lead.id, id_lead: result.lead.id, hash: result.lead.hash});
                    // store.dispatch("session/setCustomer", data_updated);
                    resolve(result)
                })
                .catch((err) => {
                    // if any error occured, then catch it here
                    console.error(
                        'Erro ao salvar customer no backeend direto na funcao',
                        err
                    )
                    reject(err)
                })
        }
    })
}

export function getShippingQuotes(zipCode) {
    let url_getquotes =
        'https://api.fornlog.com/v1.0/Shipping?action=get-cotacoes-by-products&products=64:1&cep=' +
        zipCode +
        '&services=1,2,3,4';

    return new Promise((resolve, reject) => {
        fetch(url_getquotes)
            .then((response) => response.json())
            .then(function (response) {
                if (typeof response.cotacao_win !== 'undefined' && response.cotacao_win !== null) {
                    let data_shipping = response.cotacao_win ?? {}
                    Object.assign(data_shipping, {
                        box: response.box,
                        quotes: response.melhorenvio.result,
                    })

                    resolve(data_shipping)
                }
            })
            .catch(function (error) {
                console.error("Erro ao realizar cotação direto na funcao", error)
                reject(error)
                // return error;
            })
    })
}
